module.exports = __webpack_public_path__ + "img/icon-03.53ab5493.svg";